import {messages} from '@smartmixin/i18n';
import {Question} from '@phosphor-icons/react';
import {alpha, Box, Typography, useTheme} from '@mui/material';
import {useIntl} from 'react-intl';
import ArticleList from '../../../help-center/components/ArticleList';
import PopularArticles from '../../../help-center/components/PopularArticles';
import SearchBar from '../../../help-center/components/SearchBar';
import {
  useHelpAlternates,
  useHelpBasePath,
} from '../../../help-center/hooks/useHelpLocale';
import SmartMixinHelmet from '../../../lib/SmartMixinHelmet';
import StructuredData from '../../../lib/StructuredData';

const Component = () => {
  const theme = useTheme();
  const {formatMessage} = useIntl();
  const helpBasePath = useHelpBasePath();
  const alternates = useHelpAlternates();
  const helpCenterTitle = formatMessage(messages.helpCenter.helpCenter);

  const helpCenterDescription = formatMessage(
    messages.helpCenter.landingDescription,
  );

  return (
    <>
      <SmartMixinHelmet
        title={helpCenterTitle}
        description={helpCenterDescription}
        alternates={alternates}
      />
      <StructuredData
        data={{
          type: 'BreadcrumbList',
          items: [
            {name: 'SmartMixin', url: 'https://smartmixin.io'},
            {
              name: helpCenterTitle,
              url: `https://smartmixin.io${helpBasePath}`,
            },
          ],
        }}
      />
      {/* Hero section with search */}
      <Box
        sx={{
          textAlign: 'center',
          py: {xs: 4, md: 6},
          mb: 4,
          mx: {xs: 0, md: -3},
          px: {xs: 0, md: 3},
          background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.05)} 0%, ${alpha(theme.palette.primary.light, 0.1)} 100%)`,
          borderRadius: {xs: 2, md: 3},
        }}>
        <Box
          sx={{
            width: 64,
            height: 64,
            borderRadius: 2,
            backgroundColor: alpha(theme.palette.primary.main, 0.1),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mx: 'auto',
            mb: 3,
          }}>
          <Question size={32} color={theme.palette.primary.main} />
        </Box>
        <Typography
          variant="h3"
          component="h1"
          sx={{
            fontWeight: 700,
            color: 'text.primary',
            mb: 1,
            fontSize: {xs: '1.75rem', sm: '2.5rem', md: '3rem'},
          }}>
          {helpCenterTitle}
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: 'text.secondary',
            mb: 4,
            maxWidth: 500,
            mx: 'auto',
          }}>
          {formatMessage(messages.helpCenter.landingDescription)}
        </Typography>
        <Box sx={{display: 'flex', justifyContent: 'center'}}>
          <SearchBar variant="hero" />
        </Box>
      </Box>
      {/* Popular articles (top support drivers) */}
      <PopularArticles />
      {/* Category section */}
      <Typography
        variant="h5"
        sx={{
          fontWeight: 600,
          color: 'text.primary',
          mb: 3,
        }}>
        {formatMessage(messages.helpCenter.browseByCategory)}
      </Typography>
      <ArticleList />
    </>
  );
};

Component.displayName = 'ArticleListScreen';

export {Component};
